<!--
 * @Author: LZT
 * @Date: 2024-12-12 13:27:12
 * @LastEditors: ITDLCL
 * @Description: 底部导航
 * @FilePath: \qs\src\Layout\components\FooterNav.vue
-->
<template>
  <div class="footer_nav limit-max-width">
    <van-tabbar
      class="footer-bar limit-max-width"
      v-model="data.footerActive"
      :route="false"
      safe-area-inset-bottom
      active-color="#FF2D55"
      inactive-color="#7e7e7e"
      @change="tabChange"
    >
      <van-tabbar-item
        v-for="item in tabbar"
        :name="item.name"
        :key="item.name"
      >
        <template #icon="props">
          <img :src="props.active ? item.activeIcon : item.icon" />
        </template>
        <span>{{ item.name }} </span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script setup name="footerNav">
import { replacePage } from "@/utils";
import { useRoute } from "vue-router";
import useUsersStore from "@/stores/user";
import homeIcon from "@/assets/images/icon/tabbar/home.png";
import homeActiveIcon from "@/assets/images/icon/tabbar/home_active.png";
import hangqingIcon from "@/assets/images/icon/tabbar/hangqing.png";
import hangqingActiveIcon from "@/assets/images/icon/tabbar/hangqing_active.png";
import zixuanIcon from "@/assets/images/icon/tabbar/zixuan.png";
import zixuanActiveIcon from "@/assets/images/icon/tabbar/zixuan_active.png";
import myIcon from "@/assets/images/icon/tabbar/me.png";
import myActiveIcon from "@/assets/images/icon/tabbar/me_active.png";
const userStore = useUsersStore();

const route = useRoute();
const data = reactive({
  footerActive: userStore.tabBarActive,
  dot: false
});
const appName = route.query.appName;
const tabbar = ref([
  {
    name: "首页",
    toPath: `/home/index`,
    activeIcon: homeActiveIcon,
    icon: homeIcon
  },
  {
    name: "行情",
    toPath: `/stockQuotation/index`,
    activeIcon: hangqingActiveIcon,
    icon: hangqingIcon
  },
  {
    name: "自选",
    toPath: `/optional/opt-stock`,
    activeIcon: zixuanActiveIcon,
    icon: zixuanIcon
  },
  {
    name: "我的",
    toPath: `/vip/index`,
    activeIcon: myActiveIcon,
    icon: myIcon
  }
]);
const tabChange = e => {
  const url = tabbar.value.filter(item => item.name === e)[0].toPath;
  userStore.setTabBarActive(e);
  replacePage({
    path: url,
    query: { timeKey: new Date().getTime(), appName }
  });
};
onMounted(() => {
  // 防止刷新时选中态和页面路由不一致
  const name = tabbar.value.filter(it => it.toPath === route.path)[0]?.name;
  userStore.setTabBarActive(name);
  data.footerActive = userStore.tabBarActive;
});

// 监听tabBarActive的变化，同步更新footerActive
watch(() => userStore.tabBarActive, (newVal) => {
  data.footerActive = newVal;
});
</script>

<style lang="scss" scoped>
.footer_nav {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99;
  --van-tabbar-item-active-background: transparent;
  .footer-bar {
    height: 55px;
    background: #fff;
    z-index: 10;
    right: 0;
    margin: 0 auto;
    box-shadow: 0px -1px 4px 0px #E5E9EF;
  }
  .footer-bar::after {
    border: none;
  }
}
::v-deep(.van-tabbar) {
  .van-tabbar-item {
    .van-tabbar-item__icon {
      img {
        height: 24px;
      }
    }
    .van-tabbar-item__text {
      font-size: 12px;
      line-height: 17px;
    }
  }
  .van-tabbar-item--active {
    .van-tabbar-item__text span {
      font-weight: 700;
    }
  }
}
</style>
